export default __webpack_public_path__ + "assets/bccd5599f1e670a4cf9dd5f3a80f3f16.png";